import { IsNotEmpty } from "class-validator";
import { ICaptcha } from "./captcha.interface";

export class CaptchaDto implements ICaptcha {
  @IsNotEmpty()
  token: string;
}
